export default __webpack_public_path__ + "static/media/desertcart.946e8339.png";